
export const OLD_PERMISSION_CODES = {
    // tài khoản
    WEB_USER_COMMON: 'WEB_USER_COMMON',

    // Khách hàng
    WEB_CUSTOMER_LIST: 'WEB_CUSTOMER_LIST',
    WEB_CUSTOMER_DETAIL: 'WEB_CUSTOMER_DETAIL',
    WEB_CUSTOMER_ADD: 'WEB_CUSTOMER_ADD',
    WEB_CUSTOMER_EDIT: 'WEB_CUSTOMER_EDIT',
    WEB_CUSTOMER_IMPORT: 'WEB_CUSTOMER_IMPORT',
    WEB_CUSTOMER_EXPORT: 'WEB_CUSTOMER_EXPORT',

    // Danh mục sản phẩm
    WEB_CATEGORY_LIST: 'WEB_CATEGORY_LIST',
    WEB_CATEGORY_DETAIL: 'WEB_CATEGORY_DETAIL',
    WEB_CATEGORY_ADD: 'WEB_CATEGORY_ADD',
    WEB_CATEGORY_EDIT: 'WEB_CATEGORY_EDIT',
    WEB_CATEGORY_IMPORT: 'WEB_CATEGORY_IMPORT',
    WEB_CATEGORY_EXPORT: 'WEB_CATEGORY_EXPORT',

    // Sản phẩm
    WEB_PRODUCT_LIST: 'WEB_PRODUCT_LIST',
    WEB_PRODUCT_DETAIL: 'WEB_PRODUCT_DETAIL',
    WEB_PRODUCT_ADD: 'WEB_PRODUCT_ADD',
    WEB_PRODUCT_EDIT: 'WEB_PRODUCT_EDIT',
    WEB_PRODUCT_IMPORT: 'WEB_PRODUCT_IMPORT',
    WEB_PRODUCT_EXPORT: 'WEB_PRODUCT_EXPORT',

    // phân công đơn hàng
    WEB_ORDER_ASSIGN_PICKER: 'WEB_ORDER_ASSIGN_PICKER',
    WEB_ORDER_ASSIGN_PACKER: 'WEB_ORDER_ASSIGN_PACKER',
    WEB_ORDER_ASSIGN_SHIPPER: 'WEB_ORDER_ASSIGN_SHIPPER',

    // nhặt hàng
    WEB_ORDER_PICK_DETAIL: 'WEB_ORDER_PICK_DETAIL',
    WEB_ORDER_PICK_UPDATE: 'WEB_ORDER_PICK_UPDATE',
    WEB_ORDER_PICK_DELETE: 'WEB_ORDER_PICK_DELETE',

    // kiểm tra đơn hàng
    WEB_ORDER_CHECK_DETAIL: 'WEB_ORDER_CHECK_DETAIL',
    WEB_ORDER_CHECK_UPDATE: 'WEB_ORDER_CHECK_UPDATE',
    WEB_ORDER_CHECK_DELETE: 'WEB_ORDER_CHECK_DELETE',

    // đóng gói đơn hàng
    WEB_ORDER_PACK_DETAIL: 'WEB_ORDER_PACK_DETAIL',
    WEB_ORDER_PACK_UPDATE: 'WEB_ORDER_PACK_UPDATE',
    WEB_ORDER_PACK_DELETE: 'WEB_ORDER_PACK_DELETE',

    // điều phối đơn hàng
    WEB_ORDER_SCHEDULE_DETAIL: 'WEB_ORDER_SCHEDULE_DETAIL',
    WEB_ORDER_SCHEDULE_UPDATE: 'WEB_ORDER_SCHEDULE_UPDATE',
    WEB_ORDER_SCHEDULE_DELETE: 'WEB_ORDER_SCHEDULE_DELETE',

    // giao hàng đơn hàng
    WEB_ORDER_SHIP_DETAIL: 'WEB_ORDER_SHIP_DETAIL',
    WEB_ORDER_SHIP_UPDATE: 'WEB_ORDER_SHIP_UPDATE',
    WEB_ORDER_SHIP_DELETE: 'WEB_ORDER_SHIP_DELETE',

    // đồng bềEđơn hàng
    WEB_ORDER_SYNC_SYNC: 'WEB_ORDER_SYNC_SYNC',

    // đơn hàng chung
    WEB_ORDER_COMMON_DETAIL: 'WEB_ORDER_COMMON_DETAIL',
    WEB_ORDER_COMMON_QRCODE: 'WEB_ORDER_COMMON_QRCODE',
    WEB_ORDER_COMMON_PRINT: 'WEB_ORDER_COMMON_PRINT',

    // tất cả đơn hàng
    WEB_ORDER_ALL_LIST: 'WEB_ORDER_ALL_LIST',
    WEB_ORDER_ALL_RESET_ALL: 'WEB_ORDER_ALL_RESET_ALL',

    // quét mã QR
    WEB_ORDER_SCAN_DETAIL: 'WEB_ORDER_SCAN_DETAIL',

    // Hóa đơn
    WEB_INVOICE_LIST: 'WEB_INVOICE_LIST',
    WEB_INVOICE_DETAIL: 'WEB_INVOICE_DETAIL',
    WEB_INVOICE_SYNC: 'WEB_INVOICE_SYNC',

    // Báo cáo
    WEB_REPORT_LIST: 'WEB_REPORT_LIST',
    WEB_REPORT_EXPORT: 'WEB_REPORT_EXPORT',

    // Đồng bềEuser
    WEB_SYNC_USER: 'WEB_SYNC_USER',
    
} as const; 


export const CHUC_NANG_FILTERS = {
    ORDER_PICK_UPDATE: 'ORDER_PICK_UPDATE',
    ORDER_PACK_UPDATE: 'ORDER_PACK_UPDATE',
    ORDER_SHIP_UPDATE: 'ORDER_SHIP_UPDATE',
} as const;

